export const languageOptions = {
  "en-US": {
    name: "English",
    detect: "Practice Range"
  },
  "de-DE": {
    name: "German",
    detect: "Trainingsbereich"
  },
  "es-ES": {
    name: "Spanish (Spain)",
    detect: "Práctica de combate"
  },
  "es-MX": {
    name: "Spanish (Mexico)",
    detect: "Campo de pruebas"
  },
  "fr-FR": {
    name: "French",
    detect: "Champ de tir"
  },
  "it-IT": {
    name: "Italian",
    detect: "Zona d'addestramento"
  },
  "ja-JP": {
    name: "Japanese",
    detect: "練習場"
  },
  "ko-KR": {
    name: "Korean",
    detect: "훈련장"
  },
  "pl-PL": {
    name: "Polish",
    detect: "Obszar treningowy"
  },
  "pt-BR": {
    name: "Portuguese (Brazil)",
    detect: "Campo de Treinamento"
  },
  "ru-RU": {
    name: "Russian",
    detect: "УЧЕБНЫЙ ПОЛИГОН"
  },
  "zh-CN": {
    name: "Chinese (China)",
    detect: "训练靶场"
  },
  "zh-TW": {
    name: "Chinese (Taiwan)",
    detect: "訓練中心"
  }
}
